module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_K_1.8c0a8802.mp3";